<ion-header>
    <ion-toolbar>
        <ion-title>404 - Page Not Found</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-item color="secondary">
        <ion-label class="ion-text-wrap" color="light">
            It looks like your shuttle made a wrong turn!<br />
            No worries, I'll get you back on track.
        </ion-label>
    </ion-item>
<!-- 
    <ion-item class="ion-no-padding">
        <ion-label class="ion-text-wrap" position="stacked">
            Click this button and I'll take you to the log in screen.
        </ion-label>
        <ion-button expand="full" routerLink="/login">Login</ion-button>
    </ion-item> -->
</ion-content>


<ion-footer>
    <ion-toolbar>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-button color="primary" expand="full" (click)="onLoginClick()" data-test="goToRoutes">
                        Back To Login Page
                    </ion-button>
                </ion-col>
                <ion-col>
                    <ion-button color="primary" expand="full" (click)="onBackToPreviousClick()" data-test="goToNavigation">
                        Back To Previous Page
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-toolbar>
</ion-footer>